<app-error [errcode]="errcode"></app-error>
<div class="alert-messages" *ngFor="let alert of alertsConfig | keyvalue">
   <sync-alert
   [type]="alert?.value?.type"
   [leadIcon]="alert?.value?.leadIcon"
   [showLeadIcon]="alert?.value?.showLeadIcon"
   [title]="alert?.value?.title"
   [description]="alert?.value?.description"
   [showActions]="alert?.value?.showActions"
   [primaryButtonConfig]="alert?.value?.primaryButtonConfig"
   [showPrimaryAction]="alert?.value?.showPrimaryAction"
   [secondaryButtonConfig]="alert?.value?.secondaryButtonConfig"
   [showSecondaryAction]="alert?.value?.showSecondaryAction"
   [showCloseButton]="alert?.value?.showCloseButton"
   ></sync-alert>
</div>